const en = {
  auth: {
    signingIn: 'Checking sign in status...',
    loading: 'Loading...',
    signInButton: 'Sign in',
    inactivityError: 'You were logged out due to inactivity. Please log in again',
  },
  certificationTest: {
    retakeCertificationTestTitle: 'Recertification',
    retakeCertificationTestDescription:
      'If you are about to retake a certification, your old grade will be erased, are you sure?',
  },
  certifications: {
    subtitle: 'Earn certifications to unlock projects',
    table: {
      completionDate: 'Completion date',
      numberOfQuestions: 'Number of questions',
      mark: 'Grade',
      actions: 'Actions',
    },
  },
  certification: {
    passedOn: 'Taken on {{date}}',
    table: {
      questionId: 'Question ID',
      duration: 'Time taken',
      score: 'Score',
    },
  },
  contributions: {
    title: 'My contributions',
    table: {
      projectName: 'Project name',
    },
  },
  contribution: {
    subtitle: 'Here is your activity history',
    table: {
      hit: 'Task',
    },
  },
  errorPage: {
    unknownError: 'Unknown error',
    notFound: 'Error 404: page not found',
  },
  navigation: {
    projects: 'Projects',
    certifications: 'Certifications',
    contributions: 'Contributions',
    informations: 'Information',
  },
  notifications: {
    error: 'Oops...',
    success: 'Success!',
    requestIsProcessing: 'Your request is processing',
    defaultErrorDescription: 'Error',
    user: {
      success: {
        description: 'User has been successfully updated.',
      },
      error: {
        description: 'An error occurred during the user update.',
      },
    },
  },
  projects: {
    subtitle: 'Here is your dashboard',
    displayModes: {
      cards: 'Cards',
      list: 'List',
    },
    contribute: 'Contribute',
  },
  user: {
    title: 'My information',
    profileDescription: 'This will be displayed on your profile.',
    saveChanges: 'Save changes',
    general: {
      title: 'General',
      id: 'ID',
      email: 'Email',
      phone: 'Phone',
      firstName: 'First name',
      lastName: 'Last name',
      birthDate: 'Date of birth',
      nationality: 'Nationality',
    },
    avatar: {
      title: 'Your avatar',
      description: 'It will be displayed next to your name',
    },
    sociodemographic: {
      title: 'Socio-demographic',
      earning: 'Income level',
      study: 'Education',
      family: 'Marital status',
      children: 'Number of children',
      job: 'Profession',
      activitySector: 'Business sector',
    },
    address: {
      address: 'Address',
      zipCode: 'Postal code',
      city: 'City',
      region: 'Region',
      country: 'Country',
    },
    logout: {
      label: 'Log out',
      description: 'Close your session on this device.',
    },
  },
};

export default en;
export type Translations = typeof en;
